module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-center@3x-abf85ed15d97e63785b30f09ab887889.png";